module.exports = __webpack_public_path__ + "img/line.f3d40a18.svg";